import {
    EMAIL_LOGS_ENDPOINT,
    EMAIL_LOGS_STATISTICS_ENDPOINT,
    EMAIL_LOGS_CLEANUP_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getAllEmailLogs = async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = `${process.env.REACT_APP_API_URL}${EMAIL_LOGS_ENDPOINT}${queryParams ? `?${queryParams}` : ''}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch email logs: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get email logs error:', error);
        throw error;
    }
};

export const getEmailStatistics = async () => {
    const url = `${process.env.REACT_APP_API_URL}${EMAIL_LOGS_STATISTICS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch email statistics: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get email statistics error:', error);
        throw error;
    }
};

export const cleanupOldLogs = async (daysOld = 30) => {
    const url = `${process.env.REACT_APP_API_URL}${EMAIL_LOGS_CLEANUP_ENDPOINT}?days=${daysOld}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to cleanup logs: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Cleanup logs error:', error);
        throw error;
    }
};
